import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.7 15.7"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.7 7.9c0-4.3-3.5-7.9-7.9-7.9S0 3.5 0 7.9c0 4.3 3.5 7.9 7.9 7.9 4.3-.1 7.8-3.6 7.8-7.9m-5 4.2L7.9 9.3 5 12.1l-1.4-1.4 2.8-2.8-2.8-2.8L5 3.6l2.8 2.8 2.8-2.8L12 5 9.3 7.9l2.8 2.8z" />
  </svg>
);
const SvgXCircleSolid = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="x-circle-solid" {...props} />;
export default SvgXCircleSolid;
